// Route constants
const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",

  RISK_ASSESSMENT: "/risk-assessment",
  ONBOARDING_STATUS: "/onboarding/status",
  ONBOARDING_BANK_LINKING: "/onboarding/bank-linking",
  ONBOARDING_KYC: "/onboarding/kyc",
  ONBOARDING_KRA_KYC: "/onboarding/kra-kyc",
  ONBOARDING_KYC_OFFLINE: "/onboarding/kyc-offline",
  ONBOARDING_FATCA_DETAILS: "/onboarding/fatca-details",
  ONBOARDING_NOMINEE_DETAILS: "/onboarding/nominee-details",
  CREATE_MANDATE: "/create-mandate",

  EXPLORE: "/explore",
  EXPLORE_COLLECTION_DETAILS: "/explore/mf-collection-details/:collectionId",

  INVESTMENTS: "/my-investments",
  FINANCIAL_OVERVIEW: "/financial-overview",
  FINFACTOR_BANKING: "/financial-overview/bank-account",
  FINFACTOR_BANK_DETAILS: "/financial-overview/bank-account/:bankId",
  INVESTMENT_PORTFOLIO: "/financial-overview/portfolio",
  INVESTMENT_PORTFOLIO_DETAILS: "/financial-overview/portfolio/:category",
  INVESTMENT_PORTFOLIO_BROKER: "/financial-overview/portfolio/:category/:brokerId",
  INVESTMENT_PORTFOLIO_ORDER: "/financial-overview/portfolio/:category/:brokerId/:orderId",
  FINFACTOR_INSURANCE: "/financial-overview/insurance",

  MUTUAL_FUNDS: "/mutual-funds",
  MUTUAL_FUNDS_FUND_ID: "/mutual-funds/:fundId",
  // MUTUAL_FUNDS_ADVANCE: "/mutual-funds/advance/:fundId",

  PORTFOLIO: "/portfolio",
  PORTFOLIO_MUTUAL_FUND: "/portfolio/mutual-fund",
  PORTFOLIO_MUTUAL_FUND_FUND_ID: "/portfolio/mutual-fund/:fundId",
  PORTFOLIO_MUTUAL_FUND_REDEEM: "/portfolio/mutual-fund/:fundId/redeem",
  PORTFOLIO_ORDER: "/portfolio/order",
  PORTFOLIO_ORDER_ORDER_ID: "/portfolio/order/:orderId",
  PORTFOLIO_SUMMARY: "/portfolio/summary",
  PORTFOLIO_BOND: "/portfolio/bond",
  REDEEM_FUNDS: "/redeem-funds",


  SYSTEMATIC_INVESTMENT: "/systematic-investment",

  // SIP Routes
  SIP_ROOT: "/systematic-investment/sip",
  SIP_ACTIVE: "/systematic-investment/sip/active",
  SIP_SUMMARY: "/systematic-investment/sip/summary",
  SIP_MANDATES: "/systematic-investment/sip/mandates",
  SIP_DETAILS: "/systematic-investment/sip/:sipId",

  // STP Routes
  STP_ROOT: "/systematic-investment/stp",
  STP_ACTIVE: "/systematic-investment/stp/active",
  STP_DETAILS: "/systematic-investment/stp/:stpId",

  // SWP Routes
  SWP_ROOT: "/systematic-investment/swp",
  SWP_ACTIVE: "/systematic-investment/swp/active",
  SWP_DETAILS: "/systematic-investment/swp/:swpId",

  SIPS: "/systematic-investment",
  SIPS_ACTIVE: "/systematic-investment/sip/active",
  SIPS_MANDATES: "/systematic-investment/sip/mandates",
  SIPS_SUMMARY: "/systematic-investment/sip/summary",
  SIPS_SIP_ID: "/systematic-investment/sip/:sipId",

  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_GENERAL: "/notifications/general",
  NOTIFICATIONS_IMPORTANT: "/notifications/important",

  PROFILE: "/profile",
  PROFILE_PERSONAL_DETAILS: "/profile/personal-details",
  PROFILE_NOMINEE_DETAILS: "/profile/nominee-details",
  PROFILE_BANK_DETAILS: "/profile/bank-details",
  PROFILE_ADD_BANK_ACCOUNT: "/profile/add-bank-account",
  PROFILE_ADD_NOMINEE: "/profile/add-nominee",
  PROFILE_MANDATES: "/profile/mandates",
  // TODO: below routes to be moved to onboarding routes
  DOCUMENT_UPLOAD: "/document-upload",
  SIP_DETAIL: "/sip-detail",
  PAN_CARD: "/pan-card",
  AADHAR_CARD: "/aadhar-card",

  REPORTS: "/reports",

  HELP_CENTER: "/help-center",

  // Mobile-specific routes
  SPLASH: "/splash",

  // Static/Legal pages
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",

  NOT_FOUND: "*",
};

export default ROUTES;
